<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-bind:to="{ 'name': $i18n.locale + 'Settings' }">
            {{ $t('settings') }}
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ $t('properties') }}</li>
      </ol>
    </nav>
    <div class="container-fluid">

      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">
            {{ $t('properties') }}
          </h1>
          <p class="lead text-muted">
          </p>
        </div>

      </header>

      <div class="content">
        <div class="row">
          <div class="col-md-6">
            <table class="table table-defalt table-hover" v-if="properties.length">
              <thead>
                <tr>
                  <th>{{ $t('name') }}</th>
                  <th>{{ $t('touristTax') }}</th>
                  <th>{{ $t('checkIn') }}</th>
                  <th>{{ $t('checkOut') }}</th>
                  <th>{{ $t('extraBeds') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="property in properties" @click="$router.push({ name: $i18n.locale + 'UpdateProperty', params: { property: property.slug } })">
                  <td>{{property.name}}</td>
                  <td>{{property.touristTax}}</td>
                  <td>{{property.time.checkIn}}</td>
                  <td>{{property.time.checkOut}}</td>
                  <td>{{property.stDodatnihLezisc}}</td>
                </tr>
              </tbody>

            </table>
            <router-link v-bind:to="{ 'name': $i18n.locale + 'CreateProperty' }">
              {{ $t('create') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Properties',
  data: () => ({
    title: '',
    properties: []
  }),
  created(){
    this.properties = this.$store.state.host.properties;

    /*fetch(process.env.VUE_APP_API + "/properties?host._id[]=" + host._id, {
      method: 'get',
      credentials: 'include',
      headers: {
        "Content-type": "application/json",
        "Accept": "application/json",
        "Accept-Charset": "utf-8",
        'CSRF-Token': this.$csrf
      }
    })
    .then(response => response.json())
    .then(response => {
      this.properties = response;
    })*/
  }
};
</script>


<i18n>
{
  "en": {
    "settings": "Settings",
    "properties": "Properties",
    "property": "Property",
    "create": "Create New Property",
    "name": "Name",
    "touristTax": "Tourist Tax",
    "checkIn": "Check-In Time",
    "checkOut": "Check-Out Time",
    "extraBeds": "No. of Extra Beds"
  },
  "sl": {
    "settings": "Nastavitve",
    "properties": "Nastanitve",
    "property": "Nastanitev",
    "create": "Ustvari novo nastanitev",
    "name": "Naziv",
    "touristTax": "Turistična taksa",
    "checkIn": "Čas Check-Ina",
    "checkOut": "Čas Check-Outa",
    "extraBeds": "Št. dodatnih ležišč"
  }
}
</i18n>
